import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { useEffect, useState } from "react";
import index from "./pages/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Index from "./pages/Contact/Index";
import { config } from "./pages/config";
import AboutUs from "./pages/About/AboutUs";
import Blogs from "./pages/Blog/Blogs";
import BlogDetails from "./pages/Blog/BlogDetails";
import "./assets/styles/About.css";
import Loader from "./components/common/Loader";
import ScrollToTop from "./components/common/ScrollToTop";
import Footer from "./components/common/Footer";
import CallBack from "./components/common/CallBack";
import PrivacyPolicy from "./pages/Privacy Policy/PrivacyPolicy";
import Product from "./pages/Product/Product";
import AluminiumIngots from "./pages/Product/AluminiumIngots";
import AluminiumCubes from "./pages/Product/AluminiumCubes";
import AluminiumNotchbar from "./pages/Product/AluminiumNotchbar";
import AluminiumScrap from "./pages/Product/AluminiumScrap";
function App() {
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setTimeout(() => setLoading(false), 1900)
  }, [])
  if (loading) {
    return <Loader />
  }

  return (
    <div>
      <BrowserRouter>
      <ScrollToTop />
        <Routes>
          <Route path={`${config.appUrl}`} Component={index} />
          <Route path={`${config.appUrl}contact-us`} Component={Index} />
          <Route path={`${config.appUrl}about-us`} Component={AboutUs} />
          <Route path={`${config.appUrl}product`} Component={Product} />
          <Route path={`${config.appUrl}product/aluminium-ingots`} Component={AluminiumIngots} />
          <Route path={`${config.appUrl}product/aluminium-cubes`} Component={AluminiumCubes} />
          <Route path={`${config.appUrl}product/aluminium-notchbar`} Component={AluminiumNotchbar} />
          <Route path={`${config.appUrl}product/aluminium-scrap-purchasing`} Component={AluminiumScrap} />
          <Route path={`${config.appUrl}blog`} Component={Blogs} />
          <Route path={`${config.appUrl}blog-detail/:slug`} Component={BlogDetails} />
          <Route path={`${config.appUrl}privacy-policy`} Component={PrivacyPolicy} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
